import React, { useEffect } from "react";
import { downloadFile } from "../../functions.js";


export default function ReportsDownload( { params } ) {
    const { uuid } = params;

    useEffect(() => {
        if (uuid) {
            downloadFile(`/v1/reports/files/${uuid}/`);
        }
    }, [uuid]);

    return <p></p>;
}
